import { ContentPageFeatures } from "@/components/contentPageFeatures/contentPageFeatures.comp";
import { ContentPageHero } from "@/components/contentPageHero/contentPageHero.comp";
import { Faq } from "@/components/faq/faq.comp";
import { Layout } from "@/components/layout/layout.comp";
import { getDataFromDB } from "@/lib/mongodb";
import { IContentPage } from "@/types";
import React from "react";

export default function ContentPage({
    contentPage,
}: {
    contentPage: IContentPage;
}) {
    return (
        <Layout
            showFooter={true}
            showHeader={true}
            title={contentPage.meta.title}
            description={contentPage.meta.description}
            image={contentPage.meta.imgUrl}
            url={`https://www.bracketsninja.com/about-us`}
            isDark
        >
            <ContentPageHero
                title={contentPage.name || ""}
                subtitle={contentPage.subTitle || ""}
                text={contentPage.teaser}
                isFullPage={contentPage.isFullPage}
            />
            <ContentPageFeatures contentPage={contentPage} />
            {contentPage?.faq?.length > 0 && (
                <Faq faqs={contentPage.faq.map((faq) => faq)} />
            )}
        </Layout>
    );
}

export async function getStaticProps() {
    const contentPages = await getDataFromDB<IContentPage>("content_pages", {
        slug: 'about-us',
    });
    return { props: { contentPage: contentPages[0] } };
}
